.wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooltipContent {
  font-size: 11px;
}
